import { EventEmitter, Injectable, inject } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { App } from '@df/core/app';
import { NDfModuleLoqate } from '../df-module-loqate.config';
import { LoqateService } from '../loqate.service';

export class LoqateEmailValidationEvent {
    constructor(
        public items: NDfModuleLoqate.EmailValidationItem[] | undefined,
        public email: string,
        public error: ValidationErrors | null
    ) {}
}

@Injectable({
    providedIn: 'root'
})
export class LoqateEmailValidatorService {
    protected app = inject(App);
    protected loqateService = inject(LoqateService);

    async validatorFunction(
        control: AbstractControl,
        eventEmitter?: EventEmitter<LoqateEmailValidationEvent>
    ): Promise<ValidationErrors | null> {
        if (!control.value?.length || !this.loqateService.isEnabled) {
            return null;
        }

        const items = await this.loqateService.validateEmail(control.value);

        let error: ValidationErrors | null = null;

        if (items) {
            error = this.loqateService.getEmailError(items, control.value);
        }

        if (eventEmitter) {
            eventEmitter.emit(new LoqateEmailValidationEvent(items, control.value, error));
        }

        return error;
    }

    async validate(control: AbstractControl, eventEmitter?: EventEmitter<LoqateEmailValidationEvent>): Promise<ValidationErrors | null> {
        return this.validatorFunction(control, eventEmitter);
    }
}
